var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dynamicComponents)?_c('div',{staticClass:"o-main-frame"},[_vm._l((_vm.dynamicComponents),function(item){return [_c(item,{key:item,tag:"component",attrs:{"view":_vm.view}})]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }